import React, { FC } from 'react';
import cn from 'classnames';

type Props = {
  modalOpen: boolean;
};

const ModalContainer: FC<Props> = ({ children, modalOpen }) => (
  <div
    className={cn(
      'fixed flex overflow-auto bg-black bg-opacity-50 justify-center z-1000000 left-0 top-0 w-full h-full pb-70 md:pb-none lg:py-80',
      !modalOpen && ' hidden',
    )}
  >
    {children}
  </div>
);

export default ModalContainer;
